import { c as __rest } from './chunk-525a49bc.js';
import React from 'react';

/**
 * Input string should has {{ <key> }} structure to embed provided values
 * @param props <ComplexStringProps> – contain <input> property – string with <keys> to be replaced
 * @example { input: 'Hey, {{ developer }}', developer: 'Dude' }
 */
var ComplexString = function (props) {
    var input = props.input, rest = __rest(props, ["input"]);
    var resultString = input;
    Object.keys(rest).forEach(function (key) {
        var regexp = new RegExp("{{\\s*" + key + "\\s*}}", 'gi');
        // @ts-ignore
        resultString = resultString.replace(regexp, typeof rest[key] !== 'undefined' ? rest[key].toString() : '');
    });
    return React.createElement(React.Fragment, null, resultString);
};

export { ComplexString as C };
